import { useEffect } from 'react';
import { useAlert } from '@/shared/lib/hooks/useAlert';
import { normalizeApiError, type NormalizedApiError } from '@/shared/lib/utils/apiError';
import { linkifyEmail } from '@/shared/lib/utils/linkifyEmail';

type NormalizedErrorHandler = (normalized: NormalizedApiError) => boolean;

export const useFormError = <T>(
  error: any,
  setError: any,
  resetCaptcha?: () => void,
  handleNormalizedError?: NormalizedErrorHandler,
) => {
  const onAlert = useAlert();
  useEffect(() => {
    if (!error) return;

    const normalized = normalizeApiError(error);
    if (!normalized) {
      onAlert('Произошла неизвестная ошибка', true);
      return;
    }

    if (handleNormalizedError?.(normalized)) return;

    if (normalized.format === 'inputs' && normalized.fields) {
      const object = normalized.fields;

      Object.keys(object).forEach((key) => {
        if (key === 'captcha') {
          onAlert('Произошла ошибка при проверке капчи', true);
          resetCaptcha && resetCaptcha();
        } else {
          setError(key as keyof T, {
            message: (Array.isArray(object[key]) && object[key][0]) || 'Неверный формат',
          });
        }
      });

      return;
    }

    if (normalized.format === 'new') {
      if (normalized.code === 'INVALID_REQUEST' && normalized.fields) {
        const object = normalized.fields;
        Object.keys(object).forEach((key) => {
          setError(key as keyof T, {
            message: (Array.isArray(object[key]) && object[key][0]) || 'Неверный формат',
          });
        });
        return;
      }

      onAlert(linkifyEmail(normalized.message), true);
      return;
    }

    onAlert(linkifyEmail(normalized.message), true);
  }, [error, setError, handleNormalizedError]);
};
